import { Alert, Snackbar } from '@mui/material';
import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import { ShowToastOptions, ToastContext, ToastSeverity } from './toastContext';

type ToastProviderProps = {
  children: ReactNode;
};

export const ToastProvider: FC<ToastProviderProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<ToastSeverity>('success');

  const showToast = useCallback(
    ({
      message: nextMessage,
      severity: nextSeverity = 'success',
    }: ShowToastOptions) => {
      setMessage(nextMessage);
      setSeverity(nextSeverity);
      setOpen(true);
    },
    [],
  );

  const handleClose = () => {
    setOpen(false);
  };

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};
